// extracted by mini-css-extract-plugin
export default {"form":"questionForm_form__iyyMW","options":"questionForm_options__ovVRt","popover":"questionForm_popover__3pHMu"};